var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-login',[_c('div',{staticClass:"dingding-tip-box"},[_c('h2',[_vm._v("仅支持通过钉钉工作台访问")]),_c('div',{staticClass:"dingding-tip-img"},[_c('img',{attrs:{"src":require("../../assets/images/dingdingtip.jpg"),"width":"200","height":"200"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }